import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Alert } from 'antd';
import sc from 'styled-components';

const StyledGroup = sc(Button.Group)`
  width: 100%;
  margin: 5px auto 20px auto;
  display: flex;
  justify-content: center;
`;

const StyledParagraph = sc.p`
  text-align: center;
  margin: 0 0 20px 0;
`;

const StyledDoneButton = sc(Button)`
  display: none;
  margin: 10px 10px 10px 10px;
`;

const KeyManagerCreateSuccessView = ({
  bearerToken,
  displayToken,
  onDownloadToken,
  onDisplayToken,
  onCopyToken,
  onHideModal,
}) => (
  <React.Fragment>
    <div id="key-manager-create-success">
      <StyledGroup>
        <Button icon="download" size="large" onClick={onDownloadToken}>Download</Button>
        <Button icon="eye" size="large" onClick={onDisplayToken}>Display</Button>
        <Button icon="copy" size="large" onClick={onCopyToken}>Copy to Clipboard</Button>
      </StyledGroup>
      <div style={{ display: displayToken ? 'block' : 'none' }}>
        <Input.TextArea autosize value={bearerToken} />
      </div>
      <div>
        <StyledParagraph>Copy or download this Bearer token and use it for your application</StyledParagraph>
        <Alert
          message="Warning"
          description="This Bearer token is only displayed this
          one time. It will not be displayed again once you navigate
          away from this page"
          type="warning"
          showIcon
        />
      </div>
      <StyledDoneButton type="primary" onClick={onHideModal}>Done</StyledDoneButton>
    </div>
  </React.Fragment>
);

export default KeyManagerCreateSuccessView;

KeyManagerCreateSuccessView.propTypes = {
  bearerToken: PropTypes.string,
  displayToken: PropTypes.bool.isRequired,
  onCopyToken: PropTypes.func.isRequired,
  onDisplayToken: PropTypes.func.isRequired,
  onDownloadToken: PropTypes.func.isRequired,
  onHideModal: PropTypes.func.isRequired,
};

KeyManagerCreateSuccessView.defaultProps = {
  bearerToken: '',
};
